'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VISITOR_SENDER = exports.VISITOR_SENDER = 'VISITOR_SENDER';
var AGENT_SENDER = exports.AGENT_SENDER = 'AGENT_SENDER';
var BOT_SENDER = exports.BOT_SENDER = 'BOT_SENDER';
var SYSTEM_SENDER = exports.SYSTEM_SENDER = 'SYSTEM_SENDER';
var VID_SENDER = exports.VID_SENDER = 'VID_SENDER';